import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=d8903c2e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8903c2e')) {
      api.createRecord('d8903c2e', component.options)
    } else {
      api.reload('d8903c2e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=d8903c2e&", function () {
      api.rerender('d8903c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lbuk5VZWZ3dF/JS/imageCarousel.vue"
export default component.exports